import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Icon, Card } from 'antd';
import {
    BarChart, Bar, Brush, Cell, CartesianGrid, ReferenceLine, ReferenceDot,
    XAxis, YAxis, Tooltip, Legend, ErrorBar, LabelList, Sankey, linearGradient, DemoSankeyLink, DemoSankeyNode
} from 'recharts';
import CountUp from 'react-countup'
import { updateLeaderInfo } from '../api-calls/user';
import { getAllUserWagers as getAllUserPoolWagers } from '../api-calls/poolWagers';
import { getAllUserWagers } from '../api-calls/wagers';

const ethMultiplier = 1000000000000000000;


@observer(["ViewStore", "UserStore", "AuthStore", "eventStore", "TeamStore"])
export default class MyStats extends Component {

    constructor(props) {
        super(props);

        this.state = {
            betsMade: 0,
            betsTaken: 0,
            numBetsWon: 0,
            numBetsLost: 0,
            totalAmountBet: 0,
            loading: true,
            barChartData: [],
            sankeyData: {},
            ethWon: 0,
            ethLost: 0
        };
        this.getDataForBarChart = this.getDataForBarChart.bind(this);
        this.getSankeyData = this.getSankeyData.bind(this);
        this.getDate = this.getDate.bind(this);

    }

    async componentWillMount() {
        this.props.ViewStore.changeView('My Stats');
        this.props.ViewStore.changeCurrentPage('My Stats');
        let self = this;
        setTimeout(
            function () {
                self.props.eventStore.queryEvents();
                getAllUserWagers(self.props.UserStore.user._id);
                getAllUserPoolWagers(self.props.UserStore.user._id);
            }, 1100);
    }
    componentDidMount() {
        const { UserStore } = this.props;
        let self = this;
        setTimeout(
            function () {
                self.getDataForBarChart();
            }, 1600);
    }

    getSankeyData() {
        let betsMade = this.state.betsMade;
        let betsTaken = this.state.betsTaken;
        let betsWon = this.state.numBetsWon;
        let betsLost = this.state.numBetsLost;
        let betsSettled = betsWon + betsLost;
        this.setState({
            sankeyData: {
                nodes: [
                    { name: 'Made & Taken' },
                    { name: 'Cancelled or Open' },
                    { name: 'Settled' },
                    { name: 'Won' },
                    { name: 'Lost' },
                ],
                links: [
                    { source: 0, target: 1, value: betsMade + betsTaken - betsSettled },
                    { source: 0, target: 2, value: betsSettled },
                    { source: 2, target: 3, value: betsWon },
                    { source: 2, target: 4, value: betsLost },
                ],
            }, loading: false
        });

        if (typeof this.props.AuthStore.userAuth.auth !== undefined) {
            updateLeaderInfo(this.props.AuthStore.userAuth.auth.accessToken, this.state.numBetsWon, this.state.ethWonWei);
        }
    }
    getDate(betEventId) {
        const { UserStore } = this.props;
        let theDate = Date.now();
        UserStore.betsMadeEvents.forEach(event => {
            if (event._id === betEventId) {
                theDate = event.startTime + event.duration;
            }
        });

        UserStore.betsTakenEvents.forEach(event => {
            if (event._id === betEventId) {
                theDate = event.startTime + event.duration;
            }
        });

        return theDate;
    }
    getDataForBarChart() {
        const { UserStore } = this.props;
        let dataObjectArray = [];
        let amountEthLost = 0;
        let amountEthWon = 0;
        let amountEthWonWei = 0;
        let self = this;
        let betsMade = 0;
        let betsTaken = 0;
        let numBetsLost = 0;
        let numBetsWon = 0;
        UserStore.bets.forEach(bet => {
            let thisBet = bet;
            console.log("bet = " + thisBet);
            let amount;
            if (thisBet.maker == UserStore.user._id) {
                betsMade++;
                if (thisBet.odds > 99) {
                    amount = (thisBet.value) / (thisBet.odds / 100);
                } else {
                    amount = (thisBet.value) * Math.floor(100 / thisBet.odds);
                }
                if (thisBet.maker === thisBet.winner) {
                    amountEthWon += ((amount + thisBet.value) / ethMultiplier);
                    amountEthWonWei += (amount + thisBet.value);
                    numBetsWon++;

                    dataObjectArray.push({ date: this.getDate(thisBet.eventId), loss: 0, gain: (amount + thisBet.value) / ethMultiplier });
                } else if (thisBet.taker !== "" && thisBet.winner === thisBet.taker) {
                    numBetsLost++;
                    amountEthLost += (thisBet.value / ethMultiplier);
                    console.log("amount eth lost " + amountEthLost);

                    dataObjectArray.push({ date: this.getDate(thisBet.eventId), loss: -(thisBet.value / ethMultiplier), gain: 0 });
                }

            } else {
                betsTaken++;

                if (thisBet.odds > 99) {
                    amount = (thisBet.value) / (thisBet.odds / 100);
                } else {
                    amount = (thisBet.value) * Math.floor(100 / thisBet.odds);
                }
                if (thisBet.maker === thisBet.winner) {
                    numBetsLost++;
                    amountEthLost += (amount / ethMultiplier);
                    console.log("amount eth lost " + amountEthLost);
                    dataObjectArray.push({ date: this.getDate(thisBet.eventId), loss: -amount / ethMultiplier, gain: 0 });
                } else if (thisBet.taker !== "" && thisBet.winner === thisBet.taker) {
                    amountEthWon += ((amount + thisBet.value) / ethMultiplier);
                    amountEthWonWei += (amount + thisBet.value);
                    numBetsWon++;

                    dataObjectArray.push({ date: this.getDate(thisBet.eventId), loss: 0, gain: (amount + thisBet.value) / ethMultiplier });
                }
            }

        });

        UserStore.poolBets.forEach(bet => {
           
            // Potential win logic
            let totalStake = 0;
            let stakeForYourChoice = 0;
            let event = this.props.eventStore.events.get(bet.eventId);
            event.amountBetForTeam.forEach((amount, index) => {
                if (index == bet.makerChoice - 1) {
                    stakeForYourChoice = amount;
                }

                totalStake += amount
            });
            let amountBetOnOtherTeams = totalStake - stakeForYourChoice;
            let potentialWin = 0;
    
            if (amountBetOnOtherTeams > 0) {
                potentialWin = amountBetOnOtherTeams * (bet.value / stakeForYourChoice);
            }
          

            ///
            betsMade++;
            if (bet.settled && !bet.cancelled) {
                numBetsWon++;
                amountEthWon += ((potentialWin + bet.value) / ethMultiplier);
                amountEthWonWei += (potentialWin + bet.value);
              console.log("winning id " + bet.bytes32Id);

                dataObjectArray.push({ date: this.getDate(bet.eventId), loss: 0, gain: (potentialWin + bet.value) / ethMultiplier });
            } 
            // else if (!bet.settled && !bet.cancelled) {
            //     numBetsLost++;
            //     amountEthLost += (bet.value / ethMultiplier);                
            //     dataObjectArray.push({ date: this.getDate(bet.eventId), loss: -(bet.value / ethMultiplier), gain: 0 });
            // }
        });
        console.log("data array : " + dataObjectArray);

        dataObjectArray.sort(function (a, b) {
            return (a.date - b.date);
        });

        let newArray = dataObjectArray.map((startingObj) => { return { date: new Date(startingObj.date).toLocaleDateString(), loss: startingObj.loss, gain: startingObj.gain } });




        self.setState({
            barChartData: newArray,
            betsMade: betsMade,//UserStore.betsMade.size,
            betsTaken: betsTaken,//UserStore.betsTaken.size,
            numBetsWon: numBetsWon,
            numBetsLost: numBetsLost,
            ethLost: amountEthLost,
            ethWon: amountEthWon,
            ethWonWei: amountEthWonWei,
            totalAmountBet: UserStore.user.totalAmountBet / ethMultiplier
        });

        this.getSankeyData();


    }

    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('My Stats');
    }

    render() {
        return (
            <div>
                <div className="my-stats-page">
                    <div className="my-stats-page-title">Stats</div>
                    <div className="my-stats-page-cards-container">
                        <div className="my-stats-card">
                            <div className="my-stats-card-content">
                                <div className="my-stats-card-title">Bets Made</div>
                                <div className="my-stats-card-body">
                                    <span style={{ color: '#1890ff' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <CountUp duration={1.75}
                                            separator=" "
                                            decimals={0}
                                            decimal="."
                                            suffix=" "
                                            start={0}
                                            end={this.state.betsMade} />}
                                    </span>
                                </div>

                            </div>
                            <div className="my-stats-card-content">
                                <div className="my-stats-card-title">Bets Taken</div>
                                <div className="my-stats-card-body">
                                    <span style={{ color: '#1890ff' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <CountUp duration={1.75}
                                            separator=" "
                                            decimals={0}
                                            decimal="."
                                            suffix=" "
                                            start={0}
                                            end={this.state.betsTaken} />}
                                    </span>
                                </div>
                            </div>
                            <div className="my-stats-card-content">
                                <div className="my-stats-card-title">Total Amount Bet</div>
                                <div className="my-stats-card-body">
                                    <span style={{ color: '#1890ff' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <CountUp duration={1.75}
                                            separator=" "
                                            decimals={this.state.totalAmountBet < 1 ? 3 : 2}
                                            decimal="."
                                            suffix=" "
                                            start={0}
                                            end={this.state.totalAmountBet} />}
                                    </span>
                                </div>
                            </div>
                            <div className="my-stats-card-content">
                                <div className="my-stats-card-title">Bets Won</div>
                                <div className="my-stats-card-body">
                                    <span style={{ color: '#3ac55a' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <CountUp duration={1.75}
                                            separator=" "
                                            decimals={0}
                                            decimal="."
                                            suffix=" "
                                            start={0}
                                            end={this.state.numBetsWon} />}
                                    </span>
                                </div>
                            </div>
                            <div className="my-stats-card-content">
                                <div className="my-stats-card-title">Total Amount Won</div>
                                <div className="my-stats-card-body">
                                    <span style={{ color: '#3ac55a' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <CountUp duration={1.75}
                                            separator=" "
                                            decimals={this.state.ethWon < 1 ? 3 : 2}
                                            decimal="."
                                            suffix=" "
                                            start={0}
                                            end={this.state.ethWon} />}
                                    </span>
                                </div>
                            </div>
                            {/* <div className="my-stats-card-content">
                                <div className="my-stats-card-title">Bets Lost</div>
                                <div className="my-stats-card-body">
                                    <span style={{ color: '#f72727' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <CountUp duration={1.75}
                                            separator=" "
                                            decimals={0}
                                            decimal="."
                                            suffix=" "
                                            start={0}
                                            end={this.state.numBetsLost} />}
                                    </span>
                                </div>
                            </div>
                            <div className="my-stats-card-content">
                                <div className="my-stats-card-title">Total Amount Lost</div>
                                <div className="my-stats-card-body">
                                    <span style={{ color: '#f72727' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <CountUp duration={1.75}
                                            separator=" "
                                            decimals={this.state.ethLost < 1 ? 3 : 2}
                                            decimal="."
                                            suffix=""
                                            prefix=""
                                            start={0}
                                            end={this.state.ethLost} />}
                                    </span>
                                </div>
                            </div> */}

                        </div>
                        {/* <div className="my-stats-card">
                            <div className="my-stats-card-content">
                                <div className="my-stats-card-title">Bets Taken</div>
                                <div className="my-stats-card-body">
                                    <span style={{ color: '#3ac55a' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <CountUp duration={1.75}
                                            separator=" "
                                            decimals={0}
                                            decimal="."
                                            suffix=" "
                                            start={0}
                                            end={this.state.betsTaken} />}
                                    </span>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="my-stats-card">
                            <div className="my-stats-card-content">
                                <div className="my-stats-card-title">Bets Won</div>
                                <div className="my-stats-card-body">
                                    <span style={{ color: '#3ac55a' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <CountUp duration={1.75}
                                            separator=" "
                                            decimals={0}
                                            decimal="."
                                            suffix=" "
                                            start={0}
                                            end={this.state.numBetsWon} />}
                                    </span>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="my-stats-card"> */}

                        {/* </div> */}
                        <div className="my-stats-card">
                            <div className="my-stats-card-content">
                                <div className="my-stats-card-title">ETH Gains Visualized</div>
                                <div className="my-stats-card-body">
                                    <span style={{ fontSize: "10pt", color: '#3ac55a' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <BarChart width={800} height={300} barGap={2} barSize={6} data={this.state.barChartData} margin={{ top: 20, right: 60, bottom: 0, left: 20 }}>
                                            <XAxis allowDuplicatedCategory={true} dataKey="date" />
                                            <YAxis tickCount={6} />
                                            <CartesianGrid />
                                            <Bar dataKey="loss" fill="#f72727" radius={[5, 5, 5, 5]} />
                                            <Bar dataKey="gain" fill="rgb(58, 197, 90)" radius={[5, 5, 5, 5]} />
                                            <Brush dataKey="date" height={25} />
                                            <ReferenceLine type="horizontal" value={0} stroke="#666" />
                                        </BarChart>}
                                    </span>
                                </div>
                                <br />
                                <br />
                                {/* <div className="my-stats-card-title">Bets Visualized by Status</div>
                                <div className="my-stats-card-body">
                                    <span style={{ fontSize: "10pt", color: '#3ac55a' }}>{this.state.loading ? <Icon type="loading" /> :
                                        <Sankey
                                            width={750} height={320}
                                            margin={{ top: 20, bottom: 20, left: 60 }}
                                            data={this.state.sankeyData}
                                            nodeWidth={10} nodePadding={60}
                                            linkCurvature={0.61}
                                            iterations={64}

                                        >
                                            <defs>
                                                <linearGradient id={'linkGradient'}>
                                                    <stop offset="0%" stopColor="rgba(0, 136, 254, 0.5)" />
                                                    <stop offset="100%" stopColor="rgba(0, 197, 159, 0.3)" />
                                                </linearGradient>
                                            </defs>
                                            <Tooltip />
                                        </Sankey>}
                                    </span>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/MyStats.js